import React, { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import { EntityV2Store, configStore } from '../../state/CommonState'
import off from "../../components/off.png";
import on from "../../components/on2.png";
import { DSRObject } from '../../state/Types'
import { AgTimePicker } from '../../mui-components/AgTimePicker';
import EntityDSRApi from '../../state/entitiesDsr-api'
import Download_icon from '../../assets/images/download_icon.png'
import dayjs from 'dayjs';
import { loader } from '../../util/loader';
// import zIndex from '@mui/material/styles/zIndex';

const DSRScheduler = ({ fn, dsrData }) => {
  const [toSendReports, setToSendReports] = useState(false)
  const [selectedTime, setSelectedTime] = useState(null)
  const [selectedHour, setSelectedHour] = useState(null)
  const [dsrObj, setDsrObj] = useState({})
  const DEFAULT_TIME = 10

  useSnapshot(EntityV2Store)
  const Entity = EntityV2Store.EntityRec
  const title = `View (${Entity?._id}) ${Entity?.status}`

  useEffect(() => {
    if (dsrData.status === 200) {
      dsrData = JSON.parse(JSON.stringify({ ...dsrData.data }))
      setDsrObj(dsrData)
      if (dsrData?.sendReport !== undefined) {
        setToSendReports(dsrData.sendReport)
      }
      if (dsrData?.scheduler?.days?.length > 0) {
        const updatedCheckedDays = Object.keys(checkedDays).reduce((acc, day) => {
          acc[day] = dsrData.scheduler.days.includes(dayMapping[day]);
          return acc;
        }, {});

        setCheckedDays(updatedCheckedDays);
      }
      if (dsrData?.scheduler.time !== undefined && dsrData?.scheduler.time > 0) {
        const newTime = dayjs().set('hour', dsrData.scheduler.time).startOf('hour');
        setSelectedTime(newTime);
      }

    } else {
      dsrData = new DSRObject()
      setDsrObj(dsrData)
    }

  }, [dsrData])



  const handleTimeChange = (time) => {
    if (time) {
      console.log("Time: ", time, typeof (time))
      console.log("dsrData", dsrData, dsrObj)
      const hours = dayjs(time).hour();
      const newTime = dayjs().set('hour', hours).startOf('hour');
      setSelectedTime(newTime)
      setSelectedHour(hours)
      setDsrObj((prevDsrObj) => ({
        ...prevDsrObj,
        scheduler: { ...prevDsrObj.scheduler, time: hours },
      }));
    } else {
      setSelectedTime(null)
      setSelectedHour(null)
    }
  }

  async function handleSubmit() {
    console.log("DSR OBJ")
    let data = dsrObj
    console.log('checknana', data.scheduler.time, isNaN(data.scheduler.time));

    if (isNaN(data.scheduler.time) || data.scheduler.time === null) {
      return configStore.setModalMessage('Please Select Time')
    }
    console.log("Dsrobject", data, toSendReports)
    data.entityId = EntityV2Store.EntityRec.entityId
    data.entityName = EntityV2Store.EntityRec.entityName
    data._id = `DSR_${EntityV2Store.EntityRec.entityId}`
    // if(dsrObj.scheduler?.days?.length === 0){
    if (toSendReports && (dsrObj.scheduler?.days?.length === 0 || dsrObj.scheduler?.days === undefined)) {
      return configStore.setModalMessage("Please select any one day for sending the mail")
    }
    await EntityDSRApi.createDsr(data, (data) => {
      if (data.status) {
        configStore.setModalMessage("Dsr creation sucessful")
        fn(false)
      }

    })
  }

  const toggleSendReports = () => {
    console.log("before toggle", toSendReports)
    const toggledReports = !toSendReports
    dsrObj.sendReport = toggledReports
    setToSendReports(toggledReports)
    setDsrObj(dsrObj)
    console.log("after toggle", dsrObj.sendReport)
    // const hours = dayjs(time).hour();
    if (toggledReports && (dsrObj?.scheduler?.time === undefined || dsrObj?.scheduler?.time === "")) {
      const newTime = dayjs().set('hour', DEFAULT_TIME).startOf('hour');
      setSelectedTime(newTime)
      setDsrObj((prevDsrObj) => ({
        ...prevDsrObj,
        scheduler: { ...prevDsrObj.scheduler, time: DEFAULT_TIME },
      }));
    } else {
      // dsrObj.sendReport = false
      // setSelectedTime(null)
    }

  }

  const [checkedDays, setCheckedDays] = useState({
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  })

  const dayMapping = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6
  }

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target

    setCheckedDays((prevCheckedDays) => {
      const updatedCheckedDays = {
        ...prevCheckedDays,
        [name]: checked,
      }

      const updatedDays = Object.keys(updatedCheckedDays)
        .filter((day) => updatedCheckedDays[day])
        .map((day) => dayMapping[day])

      dsrObj.scheduler.days = updatedDays
      setDsrObj(dsrObj)

      return updatedCheckedDays
    })
  }

 const handleDownloadReport = async () => {
  try {
    loader.show()

    const entityId = EntityV2Store.EntityRec.entityId;

    const { data, meta } = await EntityDSRApi.downloadDsr(entityId);

    if (!data) {
      configStore.setModalMessage("No record found");
      return;
    }

    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = meta?.fileName || `dsrReport_${entityId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();

  } catch (error) {
    configStore.setModalMessage("Download unavailable. No data found.");
  } finally {
    loader.hide()
  }
};;

  return (
    <>
      <div id="usersPg">
        <div class="back-div is-flex">
          <img
            src="./assets/Back.png"
            alt="Back"
            class="back"
            width="28px"
            onClick={() => fn(false)}
          />
          <h1 className="title ml-2">{title}</h1>
        </div>
      </div>

      <div
        className="ml-6 mr-6 mt-3"
        style={{
          borderRadius: "6px",
          padding: "6px 10px",
          display: "inline-flex",
          flexDirection: "column",
          width: "fit-content"
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: 500 }}>
          Download DSR Report
        </span>

        <button
          className="button"
          style={{ height: "30px", padding: "0 10px" }}
          onClick={handleDownloadReport}
        >
          <img
            src={Download_icon}
            alt='vfnvf'
            style={{ height: "18px", width: '18px' }}
          />
        </button>
      </div>

      <div
        className="ml-6 mr-6 mt-3"
        style={{
          border: "1px solid #eee",
          borderRadius: "6px",
          padding: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px"
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>
            Scheduler
          </span>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "13px" }}>
              Send Report
            </span>

            <button
              type="button"
              style={{ border: "none", background: "transparent" }}
              onClick={toggleSendReports}
            >
              {toSendReports ? (
                <img height="18px" width="32px" src={on} />
              ) : (
                <img height="18px" width="32px" src={off} />
              )}
            </button>
          </div>
        </div>

        <div style={{ marginBottom: "8px", fontSize: "13px" }}>
          Time:
          <AgTimePicker
            views={['hours']}
            className="ml-2"
            value={selectedTime}
            onChange={handleTimeChange}
            disabled={!toSendReports}
          />
        </div>
        <div style={{ fontSize: "13px" }}>
          Days:
          <span className="ml-2">
            {Object.keys(checkedDays).map((day) => (
              <label key={day} style={{ marginRight: "10px" }}>
                <input
                  type="checkbox"
                  name={day}
                  checked={checkedDays[day]}
                  onChange={handleCheckboxChange}
                  disabled={!toSendReports}
                  style={{ marginRight: "4px" }}
                />
                {day.slice(0, 3)}
              </label>
            ))}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
            gap: "10px"
          }}
        >
          <button className="button-cancel" onClick={() => fn(false)}>
            Cancel
          </button>

          <button className="button-submit" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </>
  )
}

export default DSRScheduler
